import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import footerLogo from "@/assets/footer-logo.png";

export const Footer = () => {
  return (
    <footer className="bg-[#221F26] text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* About Column */}
          <div>
            <div className="mb-6">
              <Link to="/" className="inline-block">
                <img 
                  src="/lovable-uploads/8ac72d70-a3d2-477b-af4a-21d4927e27a1.png" 
                  alt="Asrani Dental Logo" 
                  className="h-12 mb-4"
                />
              </Link>
              <p className="text-white/80">
                Delivering exceptional dental care with expertise and compassion for over three decades. Your smile is our greatest passion.
              </p>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <Phone size={18} className="mr-3 text-dental-highlight mt-1" />
                <div>
                  <p className="font-medium">Phone</p>
                  <a onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion && (window as any).gtag_report_conversion("tel:+918010224989"); }} href="tel:+918010224989" className="text-white/80 hover:text-dental-highlight transition-colors">+91 8010224989</a>
                </div>
              </div>
              
              <div className="flex items-start">
                <Mail size={18} className="mr-3 text-dental-highlight mt-1" />
                <div>
                  <p className="font-medium">Email</p>
                  <a href="mailto:asranisbdental@gmail.com" className="text-white/80 hover:text-dental-highlight transition-colors">asranisbdental@gmail.com</a>
                </div>
              </div>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-serif font-medium mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 hover:text-dental-highlight transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-dental-highlight transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-dental-highlight transition-colors">Our Services</Link>
              </li>
              <li>
                <Link to="/gallery" className="text-white/80 hover:text-dental-highlight transition-colors">Gallery</Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-dental-highlight transition-colors">Blog</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-dental-highlight transition-colors">Contact Us</Link>
              </li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h3 className="text-lg font-serif font-medium mb-6 text-white">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services#general-dentistry" className="text-white/80 hover:text-dental-highlight transition-colors">General Dentistry</Link>
              </li>
              <li>
                <Link to="/services#cosmetic-dentistry" className="text-white/80 hover:text-dental-highlight transition-colors">Cosmetic Dentistry</Link>
              </li>
              <li>
                <Link to="/services#orthodontics" className="text-white/80 hover:text-dental-highlight transition-colors">Orthodontics</Link>
              </li>
              <li>
                <Link to="/services#dental-implants" className="text-white/80 hover:text-dental-highlight transition-colors">Dental Implants</Link>
              </li>
              <li>
                <Link to="/services#teeth-whitening" className="text-white/80 hover:text-dental-highlight transition-colors">Teeth Whitening</Link>
              </li>
              <li>
                <Link to="/services#pediatric-dentistry" className="text-white/80 hover:text-dental-highlight transition-colors">Pediatric Dentistry</Link>
              </li>
            </ul>
          </div>
          
          {/* Office Hours */}
          <div>
            <h3 className="text-lg font-serif font-medium mb-6 text-white">Office Hours</h3>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-white/80">Monday - Friday</span>
                <div className="text-right">
                  <div className="text-sm text-white">10:00 AM - 3:00 PM</div>
                  <div className="text-sm text-white">6:00 PM - 9:00 PM</div>
                </div>
              </div>
              <div className="flex justify-between">
                <span className="text-white/80">Saturday</span>
                <div className="text-right">
                  <div className="text-sm text-white">10:00 AM - 3:00 PM</div>
                  <div className="text-sm text-white">6:00 PM - 9:00 PM</div>
                </div>
              </div>
              <div className="flex justify-between">
                <span className="text-white/80">Sunday</span>
                <div className="text-right">
                  <div className="text-sm text-white">11:00 AM - 2:00 PM</div>
                </div>
              </div>
            </div>
            
            <div className="mt-6">
              <h4 className="font-medium mb-3 text-white">Follow Us</h4>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/share/15gHkgruXU/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-[#32303A] flex items-center justify-center hover:bg-dental-highlight transition-colors" aria-label="Facebook">
                  <Facebook size={18} className="text-white" />
                </a>
                <a href="https://www.instagram.com/asranidentalclinic/" target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-[#32303A] flex items-center justify-center hover:bg-dental-highlight transition-colors" aria-label="Instagram">
                  <Instagram size={18} className="text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-[#32303A]/60">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Asrani Dental Clinic. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <ul className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-white/60">
                <li>
                  <Link to="/privacy-policy" className="hover:text-dental-highlight transition-colors">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-of-service" className="hover:text-dental-highlight transition-colors">Terms of Service</Link>
                </li>
                <li>
                  <Link to="/sitemap" className="hover:text-dental-highlight transition-colors">Sitemap</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 flex justify-center">
            <img 
              src={footerLogo} 
              alt="Footer Logo" 
              className="h-16"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};
